module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("svg")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67ac3a95"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Progress.vue
// module id = 29
// module chunks = 0